import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Student } from 'app/students/student';
import { Subject } from 'rxjs';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { ShortlistService } from '../shortlist.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-started-students',
  templateUrl: './started-students.component.html',
  styleUrls: ['./started-students.component.scss']
})
export class StartedStudentsComponent implements OnInit, AfterViewInit, OnDestroy {
  public dataSource: MatTableDataSource<Student>;
  public displayedColumns = ['studentnummer', 'studentnaam', 'crebo', 'status', 'favoriet', 'select'];  
  public destroy$ = new Subject<boolean>();

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private encryption: SemsoEncryptionModule,
    private shortlistService: ShortlistService,
    private breadcrumbService: BreadcrumbService) { }

  load() {
    this.shortlistService.getShortlist()
      .subscribe(data => {
      data.forEach(element => {
        element.type = 'crebos';
        element.studentnummerEncrypted = this.encryption.encrypt(element.studentnummer);
      });
      this.dataSource.data = data;
    });
  }

  removeFromShortlist($event, student) {
    $event.stopPropagation();
    this.shortlistService.removeFromShortlist(student.studentnummer, student.creboCode)
      .subscribe(data => {
        this.load();
        this.shortlistService.refresh();
      });
  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.load();
    this.shortlistService.update.subscribe(() => {
      this.load();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  private unselectRows() {
    this.dataSource.data.forEach(row => {
      row.active = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/students/started-students/started-students.component.ts